import { initReactI18next } from "react-i18next";

import i18n from "i18next";

import "dayjs/locale/de"; // "en" is built-in; register "de" so dayjs can localize

import translationDE from "@/locales/de/translation.json";
import translationEN from "@/locales/en/translation.json";

i18n.use(initReactI18next).init({
  fallbackLng: "de",
  // Treat an empty "" value as missing so it falls back instead of
  // rendering blank text. The i18n:no-empty CI guard should keep these
  // from landing in the first place; this is the runtime safety net.
  returnEmptyString: false,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources: {
    en: { translation: translationEN },
    de: { translation: translationDE },
  },
});

export default i18n;
